module.exports = __webpack_public_path__ + "static/img/d4_2.b282d06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/d4_2.jpg
// module id = By18
// module chunks = 0